import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formateHifDate } from '../dateFormater/dateFormater';

export const downloadLeaveReviewPDF = (rowData: any[], employeeName: string) => {
    // Create new PDF (portrait, mm, a4 size)
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // --- Header Banner Section ---
    doc.setFillColor(30, 60, 114); // Rich brand blue (#1e3c72)
    doc.rect(0, 0, pageWidth, 42, 'F');

    // Title text inside banner
    doc.setTextColor(255, 255, 255);
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(22);
    doc.text('LEAVE REVIEW REPORT', 14, 20);

    // Meta details
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Employee Name: ${employeeName || 'N/A'}`, 14, 29);
    doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 14, 35);

    // Header accent bottom border
    doc.setDrawColor(42, 82, 152); // Premium secondary blue (#2a5298)
    doc.setLineWidth(1.5);
    doc.line(0, 42, pageWidth, 42);

    // --- Statistics/Summary Card ---
    const totalLeaves = rowData.length;
    const approvedLeaves = rowData.filter(r => (r.leaveStatus || '').toLowerCase() === 'approved').length;
    const pendingLeaves = rowData.filter(r => (r.leaveStatus || '').toLowerCase() === 'pending').length;
    const rejectedLeaves = rowData.filter(r => (r.leaveStatus || '').toLowerCase() === 'rejected').length;

    // Draw Stats Card background
    doc.setFillColor(245, 247, 250); // Very light grey-blue background
    doc.rect(14, 50, pageWidth - 28, 16, 'F');
    doc.setDrawColor(218, 224, 233);
    doc.setLineWidth(0.5);
    doc.rect(14, 50, pageWidth - 28, 16, 'D');

    // Render Stats Texts
    doc.setTextColor(44, 62, 80);
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(9.5);
    doc.text(`Total Leaves: ${totalLeaves}`, 20, 60);
    doc.text(`Approved: ${approvedLeaves}`, 72, 60);
    doc.text(`Pending: ${pendingLeaves}`, 122, 60);
    doc.text(`Rejected: ${rejectedLeaves}`, 172, 60);

    // --- Leave Table Generation ---
    const tableHeaders = [
        ['Leave Type', 'From Date', 'To Date', 'Days', 'Session', 'Schedule', 'Reason', 'Status']
    ];

    const tableRows = rowData.map((row: any) => {
        return [
            row.leaveType || 'N/A',
            row.fromDate ? formateHifDate(row.fromDate) : 'N/A',
            row.toDate ? formateHifDate(row.toDate) : 'N/A',
            row.noOfDays !== undefined ? String(row.noOfDays) : '0',
            row.session || 'N/A',
            row.leavePeriod || 'N/A',
            row.reasonForLeave || 'N/A',
            (row.leaveStatus || 'Pending').toUpperCase()
        ];
    });

    autoTable(doc, {
        startY: 74,
        head: tableHeaders,
        body: tableRows,
        theme: 'striped',
        headStyles: {
            fillColor: [30, 60, 114],
            textColor: [255, 255, 255],
            fontStyle: 'bold',
            fontSize: 9,
            halign: 'left',
            valign: 'middle'
        },
        bodyStyles: {
            fontSize: 8.5,
            textColor: [60, 60, 60],
            valign: 'middle'
        },
        columnStyles: {
            0: { cellWidth: 22 }, // Leave Type
            1: { cellWidth: 22 }, // From Date
            2: { cellWidth: 22 }, // To Date
            3: { cellWidth: 12, halign: 'center' }, // Days
            4: { cellWidth: 18 }, // Session
            5: { cellWidth: 20 }, // Schedule
            6: { cellWidth: 50 }, // Reason
            7: { cellWidth: 20, fontStyle: 'bold' }  // Status
        },
        alternateRowStyles: {
            fillColor: [248, 250, 252]
        },
        margin: { left: 14, right: 14 },
        didParseCell: function(data: any) {
            // Apply custom text coloring to the Status column (index 7)
            if (data.section === 'body' && data.column.index === 7) {
                const status = (data.cell.raw || '').toLowerCase();
                if (status === 'approved') {
                    data.cell.styles.textColor = [46, 125, 50]; // Forest Green
                } else if (status === 'rejected') {
                    data.cell.styles.textColor = [211, 47, 47]; // Crimson Red
                } else {
                    data.cell.styles.textColor = [237, 108, 2]; // Dark Orange
                }
            }
        },
        didDrawPage: function(data: any) {
            // Subtle page footer separator line
            doc.setDrawColor(220, 225, 230);
            doc.setLineWidth(0.5);
            doc.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

            // Left side footer text
            doc.setFont('Helvetica', 'normal');
            doc.setFontSize(8);
            doc.setTextColor(150, 150, 150);
            doc.text('HR Management System - Confidential', 14, pageHeight - 10);

            // Right side page number
            const pageStr = `Page ${data.pageNumber}`;
            doc.text(pageStr, pageWidth - 25, pageHeight - 10);
        }
    });

    const fileSuffix = employeeName.replace(/\s+/g, '_') || 'Employee';
    const dateStr = new Date().toISOString().slice(0, 10);
    doc.save(`Leave_Review_${fileSuffix}_${dateStr}.pdf`);
};
